// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1-NBE","tab":"Tabs_tab__32DU2","tabActive":"Tabs_tabActive__1jdqN"};